import React from 'react';
import solutionIcon1 from '../../assets/imgs/nhnsolution1.svg';
import solutionIconLine1 from '../../assets/imgs/nhnSolutionLine1.svg';
import solutionIcon2 from '../../assets/imgs/nhnsolution2.svg';
import solutionIconLine2 from '../../assets/imgs/nhnSolutionLine2.svg';
import solutionIcon3 from '../../assets/imgs/nhnsolution3.svg';
import solutionIconLine3 from '../../assets/imgs/nhnSolutionLine3.svg';
import solutionIcon4 from '../../assets/imgs/nhnsolution4.svg';
import solutionIconLine4 from '../../assets/imgs/nhnSolutionLine4.svg';
import solutionIcon5 from '../../assets/imgs/nhnsolution5.svg';
import solutionIconLine5 from '../../assets/imgs/nhnSolutionLine5.svg';
import solutionIcon6 from '../../assets/imgs/nhnsolution6.svg';
import solutionIconLine6 from '../../assets/imgs/nhnSolutionLine6.svg';

const solutionData = [
  {
    title: `금융 특화 클라우드 솔루션`,
    enTitle: `Financial Specialized Solutions`,
    titleColor: '#1681FC',
    themeColor: '#1681FC',
    icon: solutionIcon1,
    lineIcon: solutionIconLine1,
    contentTitle:
      '금융 산업에 최적화된 클라우드 환경과 강력한 보안 체계를 제공합니다.',
    contentData: [
      '금융보안원 가이드라인 준수 및 보안 컴플라이언스 완비',
      ' 안정성과 이중화를 고려한 고신뢰 인프라 설계',
    ],
  },
  {
    title: `커머스 특화 클라우드 솔루션`,
    enTitle: `Commerce Specialization Solutions`,
    titleColor: '#644BEF',
    themeColor: '#513DC3',
    icon: solutionIcon2,
    lineIcon: solutionIconLine2,
    contentTitle:
      '비즈니스 성장에 유연하게 대응하는 이커머스 인프라를 제공합니다.',
    contentData: [
      '트래픽 급증 대응을 위한 오토스케일링 지원',
      '쇼핑몰·결제·배송 등 핵심 서비스를 원인프라로 구성 가능',
    ],
  },
  {
    title: `게임 특화 클라우드 솔루션`,
    enTitle: `Game Specialization Solutions`,
    titleColor: '#FF6060',
    themeColor: '#FF6060',
    icon: solutionIcon3,
    lineIcon: solutionIconLine3,
    contentTitle:
      '대규모 유저 트래픽에 강한 안정성과 글로벌 확장성을 지원합니다.',
    contentData: [
      '실시간 매칭, 랭킹, 채팅 등 게임 특화 API 제공',
      '게임 서버 자동 배포 및 멀티리전 인프라 구성',
    ],
  },
  {
    title: `공공기관 특화 클라우드 솔루션`,
    enTitle: `Public Institution Solutions`,
    titleColor: '#358AAD',
    themeColor: '#43A3AB',
    icon: solutionIcon4,
    lineIcon: solutionIconLine4,
    contentTitle: 'CSAP 인증을 통한 공공기관 전용 클라우드 환경을 제공합니다.',
    contentData: [
      '공공 보안 규정 완비 및 행정망 연계 가능',
      '온프레미스 연동을 고려한 하이브리드 구조 지원',
    ],
  },
  {
    title: `스타트업/개발자 특화 클라우드 솔루션`,
    enTitle: `
Startup Developer Specialization Solutions`,
    titleColor: '#464646',
    themeColor: '#4A4A4A',
    icon: solutionIcon5,
    lineIcon: solutionIconLine5,
    contentTitle: '빠른 개발과 실험을 위한 유연하고 경제적인 클라우드 플랫폼',
    contentData: [
      '간편한 인프라 설정과 다양한 개발 툴 지원',
      '종량제 기반으로 예산 부담 최소화',
    ],
  },
  {
    title: `엔터프라이즈 특화 클라우드 솔루션`,
    enTitle: `Smart
  Work
  Cloud Solutions`,
    titleColor: '#4368AB',
    themeColor: '#385FAD',
    icon: solutionIcon6,
    lineIcon: solutionIconLine6,
    contentTitle:
      '복잡한 IT 환경을 가진 대기업 고객을 위한 통합형 클라우드 인프라',
    contentData: [
      '멀티 클라우드 및 온프레미스 연동 지원',
      '컨설팅부터 설계, 운영까지 MSP 기반의 통합 관리',
    ],
  },
];
const NhnModalContents = ({ solutionActiveIndex }) => {
  return (
    <div className="modalWrap naverModalContent">
      <div className="flex-col gap-16 serviceDescription">
        <div
          style={{
            backgroundColor: solutionData[solutionActiveIndex].themeColor,
          }}
          className="colorBox flex-col  align-end justify-between"
        >
          <div className="titleWrap">
            <span>{solutionData[solutionActiveIndex].enTitle}</span>
          </div>
          <div className="iconWrap">
            <img src={solutionData[solutionActiveIndex].lineIcon} alt="" />
          </div>
        </div>
        <div className="contentsBox px-24 flex-full gap-32 py-32 flex-col">
          <div className="contentTitle">
            <span> {solutionData[solutionActiveIndex].contentTitle}</span>
          </div>
          <div className="divide "></div>
          <div className="contentsList flex-col gap-32">
            {solutionData[solutionActiveIndex].contentData.map((item, i) => {
              return (
                <div className={'flex-row align-center gap-24'}>
                  <div className={`contentNum`}>
                    <span>0{i + 1}</span>
                  </div>
                  <div className="content">
                    <span>{item}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

NhnModalContents.headerTitle = 'ddd';

export default NhnModalContents;
